import { searchBanksBrowse } from "../../../api/accounts.service";
import { useAccountTypeBrowse } from "../../../hooks/useAccountTypeBrowse";
import { BANK_ACCOUNT_TYPE } from "./banks.constants";

export function useBanksBrowse() {
  return useAccountTypeBrowse({
    accountType: BANK_ACCOUNT_TYPE,
    searchBrowse: searchBanksBrowse,
  });
}
